
export enum SourceGroupStatus {
  'Active' = 1,
  'Inactive',
  'Not in Use',
  'Never Used'
}

export namespace SourceGroupStatus {
  export function values() {
    return Object.keys(SourceGroupStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
